import type { Level } from './types';
import { LevelValueEnum } from './types';

const standardLevels: Array<Level> = [
  {
    value: LevelValueEnum.TOP_SECRET,
    banner: 'TOP SECRET',
    portion: 'TS',
  },
  {
    value: LevelValueEnum.SECRET,
    banner: 'SECRET',
    portion: 'S',
  },
  {
    value: LevelValueEnum.CONFIDENTIAL,
    banner: 'CONFIDENTIAL',
    portion: 'C',
  },
  {
    value: LevelValueEnum.RESTRICTED,
    banner: 'RESTRICTED',
    portion: 'R',
  },
  {
    value: LevelValueEnum.UNCLASSIFIED,
    banner: 'UNCLASSIFIED',
    portion: 'U',
  },
];

const natoLevels: Array<Level> = [
  {
    value: LevelValueEnum.TOP_SECRET,
    banner: 'COSMIC TOP SECRET',
    portion: 'CTS',
  },
  {
    value: LevelValueEnum.SECRET,
    banner: 'NATO SECRET',
    portion: 'NS',
  },
  {
    value: LevelValueEnum.CONFIDENTIAL,
    banner: 'NATO CONFIDENTIAL',
    portion: 'NC',
  },
  {
    value: LevelValueEnum.RESTRICTED,
    banner: 'NATO RESTRICTED',
    portion: 'NR',
  },
  {
    value: LevelValueEnum.UNCLASSIFIED,
    banner: 'NATO UNCLASSIFIED',
    portion: 'NU',
  },
  {
    value: LevelValueEnum.TOP_SECRET,
    modifier: '-B',
    banner: 'COSMIC TOP SECRET BOHEMIA',
    portion: 'CTS-B',
  },
  {
    value: LevelValueEnum.TOP_SECRET,
    modifier: '-A',
    banner: 'COSMIC TOP SECRET ATOMAL',
    portion: 'CTS-A',
  },
  {
    value: LevelValueEnum.SECRET,
    modifier: '-A',
    banner: 'SECRET ATOMAL',
    portion: 'NS-A',
  },
  {
    value: LevelValueEnum.CONFIDENTIAL,
    modifier: '-A',
    banner: 'CONFIDENTIAL ATOMAL',
    portion: 'NC-A',
  },
];

const levelMapping = new Map<LevelValueEnum, Level>();

standardLevels.forEach((level) => {
  levelMapping.set(level.value, level);
});

const natoLevelMapping = new Map<string, Level>();

natoLevels.forEach((level) => {
  natoLevelMapping.set(`${level.value}${level.modifier ?? ''}`, level);
});

const levelPortionMarks = new Set([
  ...standardLevels.map((level) => level.portion),
  ...natoLevels.map((level) => level.portion),
]);

const levelBannerMarks = new Set([
  ...standardLevels.map((level) => level.banner),
  ...natoLevels.map((level) => level.banner),
]);

export {
  levelMapping,
  natoLevelMapping,
  levelPortionMarks,
  levelBannerMarks,
  standardLevels,
  natoLevels,
};
